import { Injectable } from '@angular/core';
import { Log } from '../models/log.model';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';

@Injectable({ providedIn: 'root' })
export class fileUploadService {
  apiHost: string = environment.apiHost;

  constructor(private http: HttpClient, private globalService: GlobalService) {}

  uploadFile(file: any, fileName: string, type: string): Promise<string> {
    let input = new FormData();
    input.append('file', file, fileName);
    input.append('Content-Type', file.type);
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/file/fileUpload?Type=' + type, input)
        .toPromise() 
        .then( 
          (data) => { 
            if (data != null)
              resolve(data['imageUrl']);
            else
              resolve('');
          },
          (msg) => {
            reject('Internal Error: cannot upload file!');
          }
        );
    });
    return promise;   
  }

  LogoUpload(file: any, subdomain: string): Promise<string> {
    let input = new FormData();
    input.append('file', file, "icon-512x512.png");
    input.append('Content-Type', file.type);
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/file/LogoUpload?Subdomain=' + subdomain, input)
        .toPromise()
        .then(
          (data) => {
            if (data == null)
              resolve('');
            else
              resolve(data['imageUrl']);
          },
          (msg) => {
            reject('Internal Error: cannot Logo Upload!');
          }
        );
    }); 
    return promise;   
  }

  ResetLogo(subdomain: string): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/file/ResetLogo?Subdomain=' + subdomain, null)
        .toPromise()
        .then(
          (data) => {
            resolve(data['imageUrl']);
          },
          (msg) => {
            reject('Internal Error: cannot Reset Logo!');
          }
        );
    }); 
    return promise;  
  }

  importFile(file: any): Promise<string> {
    let input = new FormData();
    input.append('file', file, file.name);
    input.append('Content-Type', file.type);
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(this.apiHost + '/file/importFile', input)
        .toPromise()
        .then(
          (data) => {
            resolve(data['message']);
          },
          (msg) => {
            reject('');
          }
        );
    });
    return promise;
  }

  clearImport(): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/file/clearImport', null)
        .toPromise()
        .then(
          (data) => {
            resolve('');
          },
          (msg) => {
            reject('');
          }
        );
    });
    return promise;
  }

  deleteFile(folder: any, fileName: string): Promise<void> {
    let promise = new Promise<void>((resolve, reject) => {
      return this.http
        .post<void>(
          this.apiHost +
            '/file/DeleteFile?Folder=' +
            folder +
            '&File=' +
            fileName,
          null
        )
        .toPromise()
        .then(
          () => {
            resolve();
          },
          (msg) => {
            reject('Internal Error: cannot delete file!');
          }
        );
    });
    return promise;
  }
}
